import PropTypes from 'prop-types';
import React from 'react';

export const SmallArrow = ({ className }) => {
  return (
    <svg className={className} width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 1L3.5 4L0.5 7" stroke="#D0D0D0" strokeWidth="1.4" />
    </svg>
  );
};

SmallArrow.propTypes = {
  className: PropTypes.string,
};
